import { useMutation, useQuery } from "@apollo/client";
import { CewpUserView } from "components/cards";
import { Modal } from "components/layouts";
import { FC } from "react";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { withRoles, wrapClick } from "utils";
import { GET_CEWP_USER, RESTORE_CEWP_USER } from "./apollo";

interface RestoreCewpUserContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}

const RestoreCewpUserContainer: FC<RestoreCewpUserContainerProps> = ({
  open,
  setOpen,
  refetch,
}) => {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_CEWP_USER, {
    variables: {
      id: searchParams.id,
    },
    skip: !searchParams.id,
    notifyOnNetworkStatusChange: false,
  });

  const [restoreCEWPUser, { loading: loadingRestore }] = useMutation(
    RESTORE_CEWP_USER,
  );

  const restoreItem = async () => {
    await restoreCEWPUser({
      variables: {
        id: searchParams.id,
      },
    }).then(({ data: result }) => {
      if (result?.restoreCEWPUser?._id) {
        toast(
          JSON.stringify({
            type: "success",
            title: "CEWP User Restored Successfully",
          }),
        );
        refetch?.();
        setOpen(false);
      } else {
        toast(
          JSON.stringify({
            type: "error",
            title: "Could not restore CEWP user",
          }),
        );
      }
    });
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Restore CEWP User"
      description="Are you sure you want to restore this CEWP user?"
      renderActions={() => (
        <>
          {withRoles(["Super"])(
            <button
              type="button"
              disabled={loadingRestore}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={wrapClick(restoreItem)}
            >
              {loadingRestore ? "Restoring..." : "Restore User"}
            </button>,
          )}
        </>
      )}
    >
      {data?.user?._id && <CewpUserView user={data.user} />}
    </Modal>
  );
};

export default RestoreCewpUserContainer;
